<template>
  <div>
    <appHeader></appHeader>
    <appModal></appModal>
    <div class="container-fluid transaction-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 marginForHeader">
            <h4>Reload & Payment Methods</h4>
            <div>
              <p :style="{ 'color': 'rgba(0, 0, 0, 0.85)', 'font-size': '18px' }"><b>Please keep in mind the following:</b></p>
              <ul :style="{ 'font-weight': 600 }">
                <li>Payments made via ACH take approximately 4-5 business days to process.</li>
                <li>Funds are withdrawn from your balance when end users redeem points by placing orders, not when points are added to their accounts.</li>
              </ul>
            </div>
            <div class="card" v-if="stripeCustomerId">
              <div class="card-header">
                <b>Reload</b>
              </div>
              <div class="card-body">
                <div v-if="errorMessage" class="alert alert-danger" role="alert">
                  {{ errorMessage }}
                </div>
                <div v-if="successMessage" class="alert alert-success" role="alert">
                  {{ successMessage }}
                </div>
                <div v-if="paymentMethods.length == 0">
                  <p>
                    <b class="text-danger">Your organization is not currently set up with our Funding Service. Please click the button below to continue.</b>
                  </p>
                  <b-button @click="stripeSetup(true)" class="btn btn-dark" >Setup Billing</b-button>
                  <!--<div id="payment-element" :style="{ 'padding': '15px' }"></div>
                  <button :disabled="isLoading" class="btn btn-success" v-if="payment" @click="pay">
                      Submit Billing Details
                  </button><hr>-->
                </div>
                <p class="text-primary"><b>Current Balance: ${{ currentBalanceInDollar }}</b>
                  &nbsp;<a href="javascript:void(0)" @click="getBalance()"><i class="fas fa-sync-alt text-success"></i></a>
                </p>
                <p class="text-primary" v-if="defaultPaymentMethod && defaultPaymentMethod.id"><b>Payment Method: </b>
                  <span v-if="defaultPaymentMethod.type == 'card'"><b>{{ defaultPaymentMethod.type }}  ({{ defaultPaymentMethod.card.last4 }})</b></span>
                  <span v-if="defaultPaymentMethod.type == 'us_bank_account'">{{ defaultPaymentMethod.type }} <label v-if="defaultPaymentMethod.billing_details">({{ defaultPaymentMethod.billing_details.name }})</label></span>
                </p>
                <fieldset v-if="stripeCustomerId" :disabled="paymentMethods.length == 0">
                  <form>
                    <div class="form-row align-items-center">
                      <div class="col-md-5">
                        <div class="input-group mb-2 mr-sm-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                          </div>
                          <input type="text" placeholder="Enter Amount" class="form-control" aria-describedby="paymentFeeHelpBlock" v-model="rechargeAmount">
                        </div>
                        <small id="paymentFeeHelpBlock" class="text-primary">
                          Processing Fees <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Processing fees depends on your payment method"></i> = ${{ processingFees }}
                        </small>
                      </div>
                      <div class="col-md-5">
                        <label class="sr-only" for="inlineFormInput">Notes</label>
                        <textarea class="form-control mb-2" id="inlineFormInput" v-model="notes" placeholder="Notes"></textarea>
                      </div>
                      <div class="col-md-2">
                        <button type="button" :disabled="disabledPayButton" @click="doRecharge()" class="btn btn-primary">Reload $<span v-if="rechargeAmount > 0">{{ new Intl.NumberFormat('en-US').format(parseInt(rechargeAmount) + parseFloat(processingFees)) }}</span>
                          <span v-if="disabledPayButton"><i class="fa fa-spinner fa-spin"></i></span>
                        </button>
                      </div>
                    </div>
                  </form>
                  <hr>
                </fieldset>
              </div>
            </div>
            <div v-if="!stripeCustomerId">
              Stripe Customer has not been setup yet! Please go to the Funding
              Dashboard to get set up.
            </div>
            <div v-else>
              <!-- Tabs navs -->
              <ul class="nav nav-tabs mb-3" id="ex1" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="ex1-tab-1" data-toggle="tab" href="#ex1-tabs-1" role="tab"
                      aria-controls="ex1-tabs-1" aria-selected="true">Payment History</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="ex1-tab-2" data-toggle="tab" href="#ex1-tabs-2" role="tab" >Payment Methods</a>
                </li>
              </ul>
              <!-- Tabs navs -->

              <div class="tab-content" id="ex1-content">
                <div class="tab-pane fade show active" id="ex1-tabs-1" role="tabpanel" aria-labelledby="ex1-tab-1">
                  <div class="float-right p-1">
                    <button type="button" class="btn btn-primary" :disabled="isDisabled" @click="exportPaymentHistory()">Export<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></button>&nbsp;
                    <button type="button" class="btn btn-success" :disabled="isDisabled" @click="paymentHistory()">Refresh<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></button>
                  </div>
                  <!--  Table Start -->
                  <table class="table table-hover table-striped mb-2">
                      <thead>
                      <tr>
                          <th style="width: 10%;">Date</th>
                          <th style="width: 10%;">Funding Amount</th>
                          <th style="width: 10%;">Processing Fee</th>
                          <th style="width: 10%;">Transaction Total</th>
                          <th style="width: 10%;">By Whom</th>
                          <th style="width: 10%;">Transaction Type</th>
                          <th style="width: 10%;">Status</th>
                          <th style="width: 10%;">Notes</th>
                          
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="paymentHistory in paymentHistoryData" :key="paymentHistory.id">
                          <td>{{ paymentHistory.created_at }}</td>
                          <td>
                            $<span v-if="paymentHistory.transaction_type == 'Funds Subtracted'">-</span>{{ new Intl.NumberFormat('en-US').format(Math.abs(parseFloat((JSON.parse(paymentHistory.payment_intent_response).amount) / 100) - parseFloat(JSON.parse(paymentHistory.payment_intent_response).metadata.stripe_processing_fee_in_dollars))) }} 
                            <span class="badge badge-warning" v-if="JSON.parse(paymentHistory.payment_intent_response).is_offline_transaction">Divvy Admin</span>
                          </td>
                          <td>${{ parseFloat(JSON.parse(paymentHistory.payment_intent_response).metadata.stripe_processing_fee_in_dollars) }}</td>
                          <td>
                            <span v-if="paymentHistory.transaction_type == 'Funds Subtracted'" class="badge badge-danger"> $-{{ new Intl.NumberFormat('en-US').format(Math.abs((JSON.parse(paymentHistory.payment_intent_response).amount) / 100)) }} </span>
                            <span v-else class="badge badge-success"> ${{ new Intl.NumberFormat('en-US').format(Math.abs((JSON.parse(paymentHistory.payment_intent_response).amount) / 100)) }} </span>  
                          </td>
                          <td>
                            <span v-if="JSON.parse(paymentHistory.payment_intent_response).is_offline_transaction">  {{ paymentHistory.username }}</span>
                            <span v-else>{{ paymentHistory.hrAdminName }}</span>
                          </td>
                          <td>{{ paymentHistory.transaction_type }}</td>
                          <td>
                            <span class="badge badge-success" v-if="paymentHistory.mapped_status == 'Success'">{{ paymentHistory.mapped_status }}</span>
                            <span class="badge badge-danger" v-if="paymentHistory.mapped_status == 'Failed'">{{ paymentHistory.mapped_status }}</span>
                            <span class="badge badge-secondary" v-if="paymentHistory.mapped_status == 'Pending'">{{ paymentHistory.mapped_status }}</span>
                          </td>
                          <td>{{ paymentHistory.notes }}</td>
                      </tr>
                      <tr v-if="paymentHistoryData.length == 0">&nbsp;&nbsp;No Data Found</tr>
                      </tbody>
                  </table>
                  <!--  Table End -->
                </div>
                <div class="tab-pane fade show" id="ex1-tabs-2" role="tabpanel" aria-labelledby="ex1-tab-2">
                  <div  class="d-flex">
                    <div class="card">
                      <div class="card-header">
                        <b>Available Payment Methods</b>
                        <a class="float-right text-primary" @click="stripeSetup(true)"><i class="fa fa-plus"></i></a>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <template v-for="pm in paymentMethods">
                          <b-card v-bind:key="pm.id" :title="pm.type" class="border m-1">
                            <div v-if="pm.type == 'card'" class="d-flex flex-column">
                              <span>Brand: {{ pm.card.brand }}</span>
                              <span>Last 4 digits: {{ pm.card.last4 }}</span>
                              <span>Exp Month: {{ pm.card.exp_month }}</span>
                              <span>Exp Year: {{ pm.card.exp_year }}</span>
                            </div>
                            <div v-if="pm.type == 'us_bank_account'" class="d-flex flex-column">
                              <span>Bank Name: {{ pm.us_bank_account.bank_name }}</span>
                              <span>Billing Name: {{ pm.billing_details.name }}</span>
                              <span>Billing Email: {{ pm.billing_details.email }}</span>
                              <span>Account Type: {{ pm.us_bank_account.account_type }}</span>
                              <span>Last 4 Digit: {{ pm.us_bank_account.last4 }}</span>
                            </div>
                            <div>
                              <hr>
                              <b-button v-if="defaultPaymentMethodId != pm.id" :disabled="loading"  @click="setDefaultPaymentMethod(pm.id)" class="btn btn-warning m-1">Set as Default</b-button>
                              <b-button v-if="defaultPaymentMethodId != pm.id" :disabled="disabledPayButton" @click="deletePaymentMethod(pm.id)" class="btn btn-danger m-1">Delete <span v-if="disabledPayButton"><i class="fa fa-spinner fa-spin"></i></span></b-button>
                              <button type="button" class="btn btn-primary" v-if="defaultPaymentMethodId == pm.id">
                                Payment Method: <span class="badge badge-light">Default</span>
                              </button>
                            </div>
                          </b-card>
                        </template>
                        <b-spinner v-show="loading" variant="primary" label="Spinning"></b-spinner>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-danger" v-show="errorMessage">
              {{ errorMessage }}
            </div>
            <div class="text-success" v-show="successMessage">
              {{ successMessage }}
            </div>

            <b-modal title="Add Payment Method" size="lg"
              v-model="addPaymentMethodModel"
              scrollable
              visible hide-footer
              @close="addPaymentMethodModel = false">
              <div>
                <div class="mx-0 mx-sm-auto">
                  <div>
                    <p :style="{ 'color': 'rgba(0, 0, 0, 0.85)', 'font-size': '18px' }"><b>Please keep in mind the following:</b></p>
                    <ul :style="{ 'font-weight': 600 }">
                      <li>Payments made via ACH take approximately 4-5 business days to process.</li>
                      <li>Funds are withdrawn from your balance when end users redeem points by placing orders, not when points are added to their accounts.</li>
                    </ul>
                  </div>
                  <div id="payment-element" :style="{ 'padding': '15px' }"></div>
                  <button :disabled="isLoading" class="btn btn-success m-2 float-right" v-if="payment" @click="pay">
                      Submit Billing Details
                  </button>
                </div> 

              </div>
            </b-modal>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";
import { mapState } from "vuex";
import { GetPaymentMethods, SetDefaultPaymentMethod, GetBalance, CreateNewCustomerWithPaymentIntent } from "@/api/funding";
import FrontendService from '../../../../services/FrontendService';

export default {
  name: "PaymentMethods",
  data() {
    return {
      paymentMethods: [],
      errorMessage: "",
      loading: false,
      successMessage : "",

      disabledPayButton: false,
      isDisabled: false,
      paymentMethodID: "",
      rechargeAmount:"",
      notes: "",
      balanceInformation:"",
      currentBalanceInDollar: 0,
      paymentHistoryData: [],
      processingFees: 0,

      //Add Payment Methods
      publishKeyStripe: process.env.STRIPE_KEY,
      elementsOptions: {
        clientSecret: "",
      },
      confirmParams: {
        return_url: window.location.origin + "/funding-result", // success url
      },
      payment: null,
      isLoading: false,
      addPaymentMethodModel: false,
      defaultPaymentMethodId: "",
      defaultPaymentMethod: null,
    };
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },
  computed: {
    ...mapState({
      companyName: (state) => state.company.name,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      userClients: (state) => state.user.userClients,
      userEmail: (state) => state.user.email,
    }),
    stripeElements() {
        return this.$stripe.elements(this.elementsOptions);
    },
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "paymentMethods",
        activeMenu: this.activeMenu ? this.activeMenu : "funding",
      });
    },
    setDefaultPaymentMethod: async function (pmID) {
      this.loading = true
      this.successMessage = ""
      this.errorMessage = ""
      try {
     const resp = await SetDefaultPaymentMethod({paymentID: pmID, clientID: parseInt(this.userClients.client)})
     if (resp.status != 200) {
      this.errorMessage = `something went wrong setting the default payment method. ${resp.status} error`
     }
     else {
      this.successMessage = "Success setting default payment method!"
      this.getPaymentMethods();
     }
      }
      catch (e) {
        console.error(e)
        this.errorMessage = `Something went wrong setting the default payment method. ${e}`
      }
      finally {
        this.loading = false
      }
    },
    doRecharge() {
      this.disabledPayButton = true;
      this.successMessage = "";
      this.errorMessage = "";
      if (!this.rechargeAmount || this.rechargeAmount <= 0) {
        this.errorMessage = "Please enter amount."
        return;
      }
      let data = {
        clientID: parseInt(this.userClients.client),
        description: this.notes,
        paymentID: (this.defaultPaymentMethodId) ? this.defaultPaymentMethodId : this.paymentMethods[0].id,
        points: parseInt(this.rechargeAmount),
        amount: parseInt(this.rechargeAmount),
      }
      FrontendService.doRecharge(data)
        .then((response) => {
          this.disabledPayButton = false;
          this.rechargeAmount = 0;
          this.processingFees = 0;
          this.description = "";
          if (response.status == 200) {
            this.successMessage = "We are processing your payment. Your funds will be available momentarily.";            
            setTimeout(() => {
              this.paymentHistory();
              this.getBalance();
              this.successMessage = ""
            }, 5000)
          } else {
            this.errorMessage = response.data.message
          }
        }).catch((e) => {
          this.disabledPayButton = false;
        });
    },
    async getBalance() {
      const resp = await GetBalance({
        clientId: parseInt(this.userClients.client),
      });
      if (resp.status != 200) {
        this.errorMessage = resp.data;
      }
      this.successMessage = "Balance fetched successfully."
      this.balanceInformation = resp.data;
      if (this.balanceInformation.balance_in_dollars <= 0) {
        this.currentBalanceInDollar = Math.abs(this.balanceInformation.balance_in_dollars)
      } else {
        this.currentBalanceInDollar = Math.abs(this.balanceInformation.balance_in_dollars) * -1
      }
      this.currentBalanceInDollar = new Intl.NumberFormat('en-US').format(this.currentBalanceInDollar)
      setTimeout(() => {
        this.successMessage = ""
      }, 2000)
    },
    async paymentHistory() {
      this.isDisabled = true;
      let data = {
        client_id: parseInt(this.userClients.client), //parseInt(500951),
        status: ["Success","Pending","Failed"],
      }
      FrontendService.paymentHistory(data)
        .then((response) => {
          this.isDisabled = false;
          this.disabledPayButton = false;
          if (response.status == 200) {
            this.paymentHistoryData = response.data.data
          } else {
            this.errorMessage = response.data.message
          }
        }).catch((e) => {
          this.isDisabled = false;
          this.disabledPayButton = false;
        });
    },
    async exportPaymentHistory() {
      if (this.paymentHistoryData.length > 0) {

        let exportData = [];
        for await (let data of this.paymentHistoryData) {
          //let paymentDetail = JSON.parse(data.payment_intent_response)
          let negativeSign = (data.transaction_type == 'Funds Subtracted') ? "$-" : "$";
          exportData.push([ 
            data.created_at,
            negativeSign + Math.abs(parseFloat((JSON.parse(data.payment_intent_response).amount) / 100) - parseFloat(JSON.parse(data.payment_intent_response).metadata.stripe_processing_fee_in_dollars)),
            "$"+parseFloat(JSON.parse(data.payment_intent_response).metadata.stripe_processing_fee_in_dollars),
            negativeSign +Math.abs((JSON.parse(data.payment_intent_response).amount) / 100),
            (JSON.parse(data.payment_intent_response).is_offline_transaction) ? data.username : data.hrAdminName,
            data.transaction_type,
            data.mapped_status,
            data.notes,
          ]);
        }
        //console.log({exportData})
        this.exportToCSV(exportData);
      } else {
        this.errorMessage = "No data to export";
      }
    },
    exportToCSV(exportData = "") {
      let csv = 'Created On,Funding Amount,Processing Fees,Transaction Total,By Whom,Transaction Type,Status,Notes,\n';
      if (exportData) {
        exportData.forEach((row) => {
            csv += row.join(',');
            csv += "\n";
        });
      }
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      if (exportData) {
        anchor.download = 'PaymentHistory.csv';
      }
      anchor.click();
    },
    async deletePaymentMethod(pmID) {
      if (confirm("Are you sure you want to delete this payment method?") == true) {
        this.disabledPayButton = true;
        let data = {
          clientID: parseInt(this.userClients.client), //parseInt(500951),
          paymentID: pmID,
        }
        FrontendService.deletePaymentMethod(data)
          .then((response) => {
            this.disabledPayButton = false;
            if (response.status == 200) {
              this.getPaymentMethods();
            } else {
              this.errorMessage = response.data.message
            }
          }).catch((e) => {
            this.disabledPayButton = false;
          });
      }
    },
    async getPaymentMethods() {
      try {
        const resp = await GetPaymentMethods(this.userClients.client);
        console.log(resp);

        if (resp.status != 200) {
          this.errorMessage = resp.statusText;
          return;
        }
        this.defaultPaymentMethodId = (resp.data.default_pm) ? resp.data.default_pm.id : null;
        this.defaultPaymentMethod = resp.data.default_pm;
        this.paymentMethods = resp.data.payment_methods;
        if (this.paymentMethods.length > 0) {
          this.paymentMethodID = resp.data.default_pm_id;
        }
      } catch (e) {
        this.errorMessage = e;
      }
    },

    pay: async function () {
      this.isLoading = true;

      try {
        await this.stripeElements.submit();
        const { error } = await this.$stripe.confirmSetup({
          elements: this.stripeElements,
          clientSecret: this.elementsOptions.clientSecret,
          confirmParams: this.confirmParams,
        });

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const messageContainer = document.querySelector("#error-message");
          messageContainer.textContent = error.message;
        }
      } catch (e) {
        console.error(e);
        const messageContainer = document.querySelector("#error-message");
        messageContainer.textContent = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    stripeSetup: async function (openModal = false) {
       try {
      const payload = {
        clientID: parseInt(this.userClients.client),
        name: this.companyName,
        email: this.userEmail,
        description: "testing from frontend",
      };
      if (openModal == true) {
          this.addPaymentMethodModel = true;
        }
     
        const resp = await CreateNewCustomerWithPaymentIntent(payload);
        this.elementsOptions = {
          ...this.elementsOptions,
          clientSecret: resp.client_secret,
        };
      } catch (e) {
        console.error(e);
      }
    },
  },
  watch: {
    rechargeAmount() {
      if (this.rechargeAmount && this.rechargeAmount > 0) {
        let paymentMethodDetail = (this.defaultPaymentMethod && this.defaultPaymentMethod.type) ? this.defaultPaymentMethod : this.paymentMethods[0];
        if (paymentMethodDetail.type == "card") {
          let totalAmountInDollarsToBeCharged = (  parseInt(this.rechargeAmount) + 0.30) / (1 - 0.029);
          this.processingFees = (totalAmountInDollarsToBeCharged - parseInt(this.rechargeAmount)).toFixed(2)
        } else if (paymentMethodDetail.type == "us_bank_account") {
          let totalAmountInDollarsToBeCharged = (  parseInt(this.rechargeAmount)) / (1 - 0.008);
          let processingFees = (totalAmountInDollarsToBeCharged - parseInt(this.rechargeAmount)).toFixed(2)
          if (processingFees > 5) {
            processingFees = 5;
          }
          this.processingFees = processingFees;
        } else {
          this.processingFees = 0;
        }  
      } else {
        this.processingFees = 0;
      }
    },
    elementsOptions: {
      handler(newElementOptions, old) {
        console.log("in watch");
        this.stripeElements.update(newElementOptions);

        // Create and mount the Payment Element
        this.payment = this.stripeElements.create("payment");

        console.log("Here - ", this.payment);
      },
      deep: true,
    },
    payment(newPayment, old) {
      newPayment.mount("#payment-element");
    },
  },
  async created() {
    this.setActiveMenuItem();
    await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");
    await this.getBalance();
    await this.paymentHistory();

    // Get payment methods
    try {
      const resp = await GetPaymentMethods(this.userClients.client);

      if (resp.status != 200) {
        this.errorMessage = resp.statusText;
        return;
      }
      this.defaultPaymentMethodId = (resp.data.default_pm) ? resp.data.default_pm.id : null;
      this.defaultPaymentMethod = resp.data.default_pm;
      this.paymentMethods = resp.data.payment_methods;
      if (this.paymentMethods.length > 0) {
        if (!this.defaultPaymentMethodId) {
          this.setDefaultPaymentMethod(this.paymentMethods[0].id)
        }
        this.paymentMethodID = this.paymentMethods[0].id;
      }
    } catch (e) {
      this.errorMessage = e;
    }
  },
};
</script>


<style lang="scss" scoped>
.marginForHeader {
  margin-top: 50px;
}
.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>